import { Injectable } from '@angular/core';
import { Area } from '../../shared/enums/area.enum';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public read<T = unknown>(key: string): T | null {
    const data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data) as T;
    }

    return null;
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public tryGetArea(key: string): Area | undefined {
    let area: Area | undefined;
    const strArea = this.read<string>(key);
    if (strArea) {
      area = JSON.parse(strArea);
    }
    return area;
  }

  public write(key: string, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value));
  }
}
